//https://stackoverflow.com/questions/34338411/how-to-import-jquery-using-es6-syntax
// https://github.com/craigmichaelmartin/weather-app--birch/blob/4d9f3b03719e0a2ea3fb5ddbbfc453a10e9843c6/javascript/util/leak_jquery.js

window.$ = window.jQuery = require('jquery');